import { MessageBar, MessageBarType, ProgressIndicator, Stack } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { EventTypeEnum } from '../../../../Models/Event/EventTypeEnum';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { IEventSreachFilter } from '../../../../Models/Event/IEventSreachFilter';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../Services/API/Event/IEventApi';
import * as Services from '../../../../Services/Services';
import { strCZToDate, strToDate } from '../../../../Tools/DateTime';
import { getSchoolYears } from '../../../Consts';
import { PageTitle } from '../../../PageTitle';
import { EventTilesListView } from '../EventTileList/EventTileListView';

interface ICampListProps {
    type: EventTypeEnum;
}


export const EventListByType: React.FunctionComponent<ICampListProps> = (props) => {

    const [eventItemList, setEventItemList] = React.useState<IEventItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [filter, setFilter] = React.useState<IEventSreachFilter>({
        schoolYear: getSchoolYears(new Date(Date.now()))[0]
    });

    React.useEffect(() => {
        loadData();
    }, [])

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const groups = await ageGroupApi.getEventByFilterQuery(filter?.schoolYear, filter?.eventTypeId, filter?.district, filter?.ageGoroupId, undefined, props.type, true);

        if (groups.isSuccess && groups.data) {
            groups.data.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                const bDate = strCZToDate(b.dateOfFirstLesson);
                const aDate = strCZToDate(a.dateOfFirstLesson);
                const diff = aDate.valueOf() - bDate.valueOf();
                return diff;
            }
            )
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setEventItemList(groups.data);
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const getTitleName = (type: EventTypeEnum):string => {
        switch (type) {
            case EventTypeEnum.Lessons: return "Kurzy";
            case EventTypeEnum.Camp: return "Tábory";
            case EventTypeEnum.Training: return "Školení";
            default:return "Neznámý typ"
        }
    }

    return (<>
        <Stack styles={{ root: { height: 10 } }}>
            {isLoading ? <ProgressIndicator /> : null}
        </Stack>
        <EventTilesListView events={eventItemList} />
        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
    </>
    )
}

